import API from './api';
import { exportResults, convertParams } from '../utils/index';
import { HTTP } from '../config/http-common';

export default class CourseFolders extends API {
    createMultiCourse = async (body) => exportResults(await HTTP.post(`${this.ROUTE}/create_multi_item`, body));
}
